import { render, staticRenderFns } from "./w-field.vue?vue&type=template&id=2fcbca4e"
import script from "./w-field.vue?vue&type=script&lang=js"
export * from "./w-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports